import Vue from "vue"
import Vuex from "vuex"
import {getSessionKey} from '../common/utils'

Vue.use(Vuex)

const store = new Vuex.Store({

  state:{
    sidebar:{
      collapsed:getSessionKey('state.sidebar.collapsed','false') === 'true',
      show:getSessionKey('state.sidebar.show','true')==='true'
    },
    device:{
      isMobile:false
    },
    currentMenus:[],
    userInfo:{userName:''},
    items:[],
    authorization: false
  },
  getters:{
    sidebar: state => state.sidebar,
    device:state => state.device,
    currentMenus:state => state.currentMenus,
    userInfo: state =>state.userInfo,
    items: state =>state.items
  },
  mutations:{
    loadCurrentMenu(state, menu) {
      state.currentMenus = menu;
    },
    toggleDevice(state,isMobile){
      state.device.isMobile = isMobile;
    },
    setUserInfo(state, info) {
      state.userInfo = window.localStorage.getItem("user-info");
    },
    toggleSidebar(state,collapsed){
      if(collapsed == null){
        collapsed = !state.sidebar.collapsed;
        state.sidebar.collapsed = collapsed;
        window.sessionStorage.setItem("state.sidebar.collapsed",collapsed);
      }
    },
    toggleSidebarShow(state,show){
      if(show == null){
        state.sidebar.show = !state.sidebar.show;
      }else{
        state.sidebar.show = show;
      }
      window.sessionStorage.setItem("state.sidebar.show",state.sidebar.show)
    },

    setData(state,items){
      state.items = items;
    },

    setAuthorization(state,authorization){
      state.authorization = authorization
    }
  },
  actions:{
    changeCurrentMenu: ({state,commit},{path,matched,fullPath}) => {
      const a = getCurrentMenu(fullPath,state.menuList);
      commit(types.LOAD_CURRENT_MENU, a.reverse());
    }
  }
})

export default store;


// WEBPACK FOOTER //
// ./src/store/index.js